var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40576 3.34182C5.31176 2.56046 6.57359 2 8 2C10.6902 2 12.9233 3.99944 13.1657 6.57898C14.7581 6.80411 16 8.13656 16 9.77273C16 11.5695 14.5023 13 12.6875 13H3.78125C1.70754 13 0 11.366 0 9.31818C0 7.55511 1.26586 6.09512 2.94223 5.725C3.08479 4.8617 3.63985 4.00237 4.40576 3.34182ZM5.05886 4.09909C4.30231 4.75157 3.90625 5.5383 3.90625 6.15455V6.6026L3.46088 6.65155C2.06371 6.80512 1 7.95266 1 9.31818C1 10.7849 2.23059 12 3.78125 12H12.6875C13.9793 12 15 10.9884 15 9.77273C15 8.55703 13.9793 7.54545 12.6875 7.54545H12.1875V7.04545C12.1875 4.8256 10.3273 3 8 3C6.83758 3 5.80253 3.45773 5.05886 4.09909Z",
    fill: "#FF8F9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.4a6557350a8d656ec03f00c20ad780ac.svg";
export { ForwardRef as ReactComponent };